module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sidebarCurrentPanel === 'triggerbutton'),
      expression: "sidebarCurrentPanel === 'triggerbutton'"
    }],
    staticClass: "kp-modular-submenu kp-modular-submenu-tab kp-animate-tab-open"
  }, [_c('div', {
    staticClass: "kp-modular-tab pt-page no-fade pt-page-current"
  }, [_c('header', {
    staticClass: "kp-modular-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('edit.sidebar.call_button')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "submenu-content sub-color"
  }, [_c('header-config'), _vm._v(" "), _c('div', {
    staticClass: "submenu-padding"
  }, [_c('options-config'), _vm._v(" "), (_vm.boxConfig.trigger_button.kind === 'basic') ? _c('span', [_c('background-color-config'), _vm._v(" "), _c('text-color-config'), _vm._v(" "), _c('align-config'), _vm._v(" "), _c('font-size-config'), _vm._v(" "), _c('border-radius-config'), _vm._v(" "), _c('width-config'), _vm._v(" "), _c('height-config')], 1) : _vm._e()], 1)], 1)])])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-64b253ff!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/triggerbutton/Main.vue
 ** module id = 849
 ** module chunks = 1
 **/